var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"foot-box"},[_c('a',{attrs:{"href":"###"}},[_vm._v("©晶澳太阳能科技股份有限公司版权所有")]),_c('a',{attrs:{"href":"###"}},[_vm._v("2020年")]),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("冀ICP备20009525号-1")])])])
}]

export { render, staticRenderFns }